module.exports = __webpack_public_path__ + "img/touchdown.1b1c8a63.jpg";